/**
 * Reference vocabularies for tasks -- client mirror of
 * server/src/components/task_types.js. Keep the two in sync.
 */

export const TYPES = [
    {value: 'book', label: 'Book'},
    {value: 'confirm', label: 'Confirm'},
    {value: 'payment', label: 'Payment'},
    {value: 'follow-up', label: 'Follow-Up'},
    {value: 'general', label: 'General'}
];

export const STATUSES = [
    {value: 'planned', label: 'Planned'},
    {value: 'booked', label: 'Booked'},
    {value: 'confirmed', label: 'Confirmed'},
    {value: 'ticketed', label: 'Ticketed'}
];

export const PAYMENTS = [
    {value: 'unpaid', label: 'Unpaid'},
    {value: 'deposit', label: 'Deposit'},
    {value: 'paid', label: 'Paid'},
    {value: 'card_on_file', label: 'Card on File'},
    {value: 'na', label: 'N/A'}
];

export function typeLabel(value) {
    const type = TYPES.find(t => t.value === value);
    return type ? type.label : value;
}

export function statusLabel(value) {
    const status = STATUSES.find(s => s.value === value);
    return status ? status.label : value;
}

export function paymentLabel(value) {
    const payment = PAYMENTS.find(p => p.value === value);
    return payment ? payment.label : value;
}
